import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      internationalPreview: {
        SAMPLE_REPORT: 'Sample report',
        CREATE_REQUEST: 'Create Request',
        BUSINESS_CONCIERGE: 'Business Concierge Service',
        BUSINESS_CONCIERGE_DETAIL:
          'For those who are unable to locate information on a particular firm, our team of experts at the Business Concierge Service can assist in obtaining official company documents from anywhere in the world. Upon contacting us, we will conduct research on the availability of the requested document. This service entails a handling fee per researched company, a fee for document services, and an official government fee that may differ based on the nation and type of document.',
        COMPANY_DETAIL_FOR: 'The company details for',
        COMPANY_SOURCE:
          'are sourced directly or indirectly from official company registries',
        COMPANY_NAME: 'Company Name',
        REPORT_TYPE: 'Report Type',
        LEAVE_US_MESSAGE:
          'Leave a message if you have any requirements or need more information',
        SUBMIT: 'Submit',
        CANCEL: 'Cancel',
        CLOSE: 'Close',
        CONFIRMATION: 'Confirmation',
        CONFIRM_MESSAGE: `<b>Your request was submitted successfully.</b> <br/> A confirmation will be sent to your email address. Please check your mailbox regularly for our updates.<br/>Thank you for using our service!`,
        REGISTRATION_NUMBER: 'Registration Number',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      internationalPreview: {
        SAMPLE_REPORT: 'Báo cáo mẫu',
        CREATE_REQUEST: 'Tạo Yêu Cầu',
        BUSINESS_CONCIERGE: 'Dịch Vụ Business Concierge',
        BUSINESS_CONCIERGE_DETAIL:
          'Nếu bạn gặp khó khăn khi tìm kiếm thông tin doanh nghiệp, dịch vụ Business Concierge sẽ giúp bạn có được tài liệu chính thức từ các doanh nghiệp trên toàn cầu. Chúng tôi sẽ xem xét tính khả dụng của dữ liệu ngay khi được yêu cầu. Dịch vụ này bao gồm phí tìm kiếm cho mỗi công ty, phí dịch vụ tài liệu và phí từ phía chính phủ. Các loại phí có thể thay đổi tùy theo quốc gia và loại tài liệu.',
        COMPANY_DETAIL_FOR: 'Thông tin chi tiết về công ty',
        COMPANY_SOURCE:
          'được lấy nguồn trực tiếp hoặc gián tiếp từ các cơ quan đăng ký doanh nghiệp chính thức.',
        COMPANY_NAME: 'Tên Công Ty',
        REPORT_TYPE: 'Loại Báo Cáo',
        LEAVE_US_MESSAGE:
          'Để lại lời nhắn nếu bạn có bất kỳ yêu cầu hoặc cần thêm thông tin',
        SUBMIT: 'Gửi yêu cầu',
        CANCEL: 'Hủy',
        CLOSE: 'Đóng',
        CONFIRMATION: 'Xác nhận',
        CONFIRM_MESSAGE: `<b>Yêu cầu của bạn đã được gửi thành công.</b> <br/> Thư xác nhận sẽ được gửi đến email của bạn. Vui lòng kiểm tra email thường xuyên, chúng tôi sẽ liên hệ bạn sớm nhất có thể.
        <br/> Cảm ơn bạn đã sử dụng dịch vụ của FiinGate!`,
        REGISTRATION_NUMBER: 'Số Đăng Ký Doanh Nghiệp',
      },
    },
  }),
)
